import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CardTitle from "@saleor/components/CardTitle";
import React from "react";

import { StoreOrderDetails_storeOrder_order_rider } from "../../types/StoreOrderDetails";

export interface OrderAssignedRiderProps {
  riderData: StoreOrderDetails_storeOrder_order_rider;
}

const useStyles = makeStyles(
  theme => ({
    assignRiderHeader: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "14px"
      }
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 600,
      textAlign: "left"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "left"
    }
  }),
  { name: "OrderAssignedRider" }
);

const OrderAssignedRider: React.FC<OrderAssignedRiderProps> = props => {
  const { riderData } = props;
  const classes = useStyles(props);
  return (
    <Card>
      <CardTitle title="Assigned Rider" />
      <CardContent>
        {riderData ? (
          <table className={classes.root}>
            <tbody>
              <tr>
                <th className={classes.textBold}>Name</th>
                <td className={classes.textRight}>
                  {riderData.firstName} {riderData.lastName}
                </td>
              </tr>
              <tr>
                <th className={classes.textBold}>Email Address</th>
                <td className={classes.textRight}>{riderData.email}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>Contact Number</th>
                <td className={classes.textRight}>{riderData.contactNo}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <Typography variant="subtitle1">
            No assigned rider to be shown
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

OrderAssignedRider.displayName = "AssignedRider";
export default OrderAssignedRider;
